<template>
  <b-card no-body>
    <!-- <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2"
        >
          <label>Tìm kiếm</label>
          <b-input-group>
            <b-form-input
              v-model="localSearchQuery"
              class="d-inline-block"
              placeholder="Từ khóa"
              @keyup.enter="updateSearchQuery"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click="updateSearchQuery"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>

        </b-col>
      </b-row>
    </b-card-body> -->
    <div class="card-body p-1">
      <div class="row">
        <div class="col-12 col-md-4">
          <b-form-group
            label="Từ khóa"
            label-for="title"
          >
            <b-form-input
              id="title"
              v-model="localSearchQuery.keyword"
              class="d-inline-block"
              placeholder="Nội dung mượn"
              @keyup.enter="updateSearchQuery"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
            label="Ngày tạo"
            label-for="created_at"
          >
            <div class="input-group">
              <flat-pickr
                v-model="localSearchQuery.created_at"
                class="form-control"
                :config="configDateRange"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-default"
                  style="border-color: #d8d6de;"
                  type="button"
                  title="Xóa"
                  data-clear
                >
                  <feather-icon icon="XIcon" />
                </button>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
            label="Ngày bắt đầu mượn"
            label-for="borr"
          >
            <div class="input-group">
              <flat-pickr
                v-model="localSearchQuery.borrow_begin_date"
                :value="localSearchQuery.borrow_begin_date"
                class="form-control"
                :config="configDateRange"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-default"
                  style="border-color: #d8d6de;"
                  type="button"
                  title="Xóa"
                  data-clear
                >
                  <feather-icon icon="XIcon" />
                </button>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
            label="Ngày dự kiến trả"
            label-for="borr"
          >
            <div class="input-group">
              <flat-pickr
                v-model="localSearchQuery.plan_date"
                :value="localSearchQuery.plan_date"
                class="form-control"
                :config="configDateRange"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-default"
                  style="border-color: #d8d6de;"
                  type="button"
                  title="Xóa"
                  data-clear
                >
                  <feather-icon icon="XIcon" />
                </button>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
            label="Ngày trả"
            label-for="borr"
          >
            <div class="input-group">
              <flat-pickr
                v-model="localSearchQuery.real_pay_date"
                :value="localSearchQuery.real_pay_date"
                class="form-control"
                :config="configDateRange"
                placeholder="dd/mm/yyyy - dd/mm/yyyy"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-default"
                  style="border-color: #d8d6de;"
                  type="button"
                  title="Xóa"
                  data-clear
                >
                  <feather-icon icon="XIcon" />
                </button>
              </div>
            </div>
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
            label="Trạng thái"
            label-for="borr"
          >
            <v-select
              v-model="localSearchQuery.status"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :value="statusFilter"
              :options="statusOptions"
              class="w-100"
              :reduce="(val) => val.id"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-4">
          <b-form-group
            label="Người đặt"
            class="author"
            label-for="author"
          >
            <v-select
              v-model="localSearchQuery.created_by"
              multiple
              label="username"
              :filterable="false"
              :options="dataCreatedBy"
              :reduce="val => val.id"
              @search="onSearch"
            >
              <template slot="no-options">
                Nhập tên tài khoản
              </template>
              <template
                slot="option"
                slot-scope="option"
              >
                <div class="d-center">
                  {{ option.alias }}
                </div>
              </template>
              <template
                slot="selected-option"
                slot-scope="option"
              >
                <div class="selected d-center">
                  {{ option.alias }}
                </div>
              </template>
            </v-select>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4">
          <b-button
            variant="primary"
            @click="updateSearchQuery"
            @keyup.enter="updateSearchQuery"
          >
            <feather-icon icon="SearchIcon" /> Tìm kiếm
          </b-button>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormGroup,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
// import useCategoryTypeDevice from './useCategoryTypeDevice';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import vSelect from 'vue-select';
import axios from '@axios';
import _ from 'lodash';
import useBorrow from './useBorrow';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    flatPickr,
    BFormGroup,
    vSelect,
  },
  props: {
    searchQuery: ref({}),
    statusFilter: {
      type: [Number, null],
      default: null,
    },
  },
  methods: {
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      } else {
        loading(false);
      }
    },
    search: _.debounce((loading, search, vm) => {
      axios.get(`users/search?keyword=${(search)}`).then((response) => {
        if (vm.dataCreatedBy.length < 1 && response.data.data.length > 0) {
          vm.dataCreatedBy = response.data.data;
        } else {
          const dataNews = [];
          vm.dataCreatedBy.map((item) => {
            if (vm.localSearchQuery.created_by.includes(item.id)) {
              dataNews.push(item);
            }
          });
          if (response.data.data.length > 0) {
            response.data.data.map((item) => {
              if (!vm.localSearchQuery.created_by.includes(item.id)) {
                dataNews.push(item);
              }
            });
          }
          const sortedObjs = _.sortBy(dataNews, 'full_name');
          vm.dataCreatedBy = sortedObjs;
        }
        loading(false);
      });
    }, 500),
  },
  setup(props, { emit }) {
    const { statusOptions } = useBorrow();
    const localSearchQuery = ref({
      created_at: '',
      borrow_begin_date: '',
      plan_date: '',
      real_pay_date: '',
      keyword: '',
      status: '',
      created_by: [],
    });
    const dataCreatedBy = ref([]);
    const updateSearchQuery = () => {
      emit('search', localSearchQuery.value);
    };
    Vietnamese.rangeSeparator = ' - ';
    const configDate = ref({
      dateFormat: 'd/m/Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    const configDateRange = ref({
      dateFormat: 'd/m/Y',
      mode: 'range',
      wrap: true,
      showMonths: 2,
      locale: Vietnamese, // locale for this instance only
    });

    return {
      localSearchQuery,
      updateSearchQuery,
      configDate,
      configDateRange,
      statusOptions,
      dataCreatedBy,
    };
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
